import { useEffect, useState } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { Product } from "../../Support/Account/AddOnsSupport/types";

export const transformPlan = (planData: Product): Product => {
  const splitName = planData.name.split(" - ");
  return {
    ...planData,
    baseName: splitName[0],
    tier: splitName[splitName.length - 1],
  };
};

const useProducts = (productFamilySlug?: string) => {
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    caseTransformingAxios
      .get("/products", { params: { productFamilySlug } })
      .then(({ data }) =>
        setProducts(
          (data as Product[]).map(transformPlan).sort((a, b) => a.details.unitPrice - b.details.unitPrice),
        ),
      )
      .catch(() => setProducts([]));
  }, []);

  return products;
};

export default useProducts;
